import { onUnmounted, ref } from 'vue';

/**
 * Schedules a callback on full clock boundaries for the supplied interval,
 * such as every full minute or hour, and cleans up on component unmount.
 */
export function useTimer(callback, intervalInMilliseconds) {
  const timer = ref(null);
  const isRunning = ref(false);

  const stop = () => {
    isRunning.value = false;
    if (timer.value !== null) {
      clearTimeout(timer.value);
      timer.value = null;
    }
  };

  const scheduleNextTick = () => {
    if (!isRunning.value) return;

    const millisecondsToNextInterval =
      intervalInMilliseconds - (Date.now() % intervalInMilliseconds);

    timer.value = setTimeout(() => {
      if (!isRunning.value) return;

      callback();
      scheduleNextTick();
    }, millisecondsToNextInterval);
  };

  const start = () => {
    if (!isRunning.value) {
      isRunning.value = true;
      scheduleNextTick();
    }
  };

  onUnmounted(stop);

  return { start, stop };
}
